import * as React from "react";

import { MediaQueryInfo } from "../responsive/Responsive.types";

/**
 * React context variable to store state of currently active media query. Intended for responsive
 * design use
 */
export const MediaQueryContext = React.createContext<MediaQueryInfo | null>(
  null
);
